<template>
  <log-quick-submit
    v-model="comment"
    :placeholder="$t('ACTIVITY.COMMENTS.COMMENT_PLACEHOLDER')"
    :return-placeholder="$t('ACTIVITY.COMMENTS.RETURN_PLACEHOLDER')"
    :loading="isPending"
    @submit="submitComment"
  >
    <template #actionBar>
      <avatar-with-name
        :user="currentUser || {}"
        data-cy="log-comment-author"
      />
    </template>
  </log-quick-submit>
</template>

<script lang="ts">
import { inject, ref } from "vue";

import { CommunicationLogContextKey } from "@/helpers/symbols";
import { useAuth } from "@/hooks/auth";
import { useCreateCommentMutation } from "@/hooks/queries/useInbox";

import LogQuickSubmit from "@/components/communicationLogs/forms/LogQuickSubmit.vue";
import AvatarWithName from "@/components/ui/AvatarWithName.vue";
</script>

<script setup lang="ts">
const { currentUser } = useAuth();

const context = inject(CommunicationLogContextKey, {
  type: null,
  logId: null,
});

const comment = ref("");

const { mutateAsync, isPending } = useCreateCommentMutation();

const submitComment = async () => {
  if (!comment.value || !context.type || !context.logId) {
    return;
  }
  await mutateAsync({
    comment: comment.value,
    type: context.type,
    logId: context.logId,
  });
  comment.value = "";
};
</script>
